export default __webpack_public_path__ + "static/media/Rectangle29.c53004c5.jpg";